import { alertBar } from "client_legacy/ndaw/alertBar";
import { SharePointEvent, publish } from "./../documentEvents";
import { deleteDocuments } from "client/Api/Documents/SharePoint/sharePointAction";
import { DocumentItemViewModel, ListLocationModel } from "client/Api/Documents/SharePoint/common";
import { localize } from "client_legacy/ndaw/culture";
import { ArgumentNotSuppliedError } from "client_legacy/ndaw/errors";
import { showConfirmationDialog } from "client/Components";
import {
	FailedItem,
	openNotAllItemsWereDeletedDialog
} from "client/Features/Documents/Dialogs/NotAllItemsWereDeletedDialog";

export function deleteItems(
	location: ListLocationModel,
	items: readonly DocumentItemViewModel[],
	successCallback?: () => void
): void {
	if (!location) {
		throw new ArgumentNotSuppliedError("location");
	}

	if (!items || items.length === 0) {
		throw new ArgumentNotSuppliedError("documents");
	}

	const title: string = items.length > 1
		? localize("_DeleteThisItems").replace("{itemCount}", items.length.toString())
		: localize("_DeleteThisItem");

	const message: string = items.length > 1
		? localize("_ItemsMovedToRecycleBin")
		: localize("_ItemMovedToRecycleBin");

	showConfirmationDialog({
		trackingId: "delete-items-confirmation-dialog",
		title,
		message: message,
		confirmText: localize("_Delete"),
		cancelText: localize("_Cancel"),
		onConfirmation: async () => {
			const itemIds: number[] = items.map(x => x.id);
			await deleteDocuments(location, itemIds)
				.then(
					(response) => {
						if (response.failedItems.length > 0) {
							const failedItems: FailedItem[] = response.failedItems
								.map(x => ({ name: x.itemName, reason: x.errorMessage }));

							openNotAllItemsWereDeletedDialog({
								failedItems,
								showReasons: true
							});
						} else {
							alertBar.showTextAlert(localize("_FilesDeletedSuccessfully"), "success");
						}

						publish(SharePointEvent.Deleted, items.filter(
							x => response.deletedItems.includes(x.id)
						));

						if (successCallback) {
							successCallback();
						}
					},
					() => {
						alertBar.showTextAlert(localize("_GeneralErrorMessage"), "error");
					}
				);
		}
	});
}
